<div class="flex flex-col gap-8">
  <span class="text-[18px] font-bold">Cumplimiento ISO 42001</span>

  <div class="flex flex-col gap-6">
    <span class="text-[16px] font-semibold">Sistema de gestion de IA</span>

    <div class="grid grid-cols-2 gap-8">
      <div class="flex gap-3 items-start">
        <input
          *ngIf="reviewMode && !readonlyReview"
          type="checkbox"
          class="mt-1"
          [checked]="reviewFields.isFieldMarked('iso42001Check')"
          (change)="reviewFields.toggleField('iso42001Check')" />
        <div class="flex flex-col gap-2">
          <div class="flex items-start gap-2">
            <span class="text-[14px] text-neutral-dark">Validacion contra controles ISO 42001</span>
            <app-tooltip
              *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('iso42001Check')"
              class="-mt-2"
              [description]="previousReviewText('iso42001Check')"
              tipeIcon="info"></app-tooltip>
          </div>
          <span class="text-[16px] font-regular">
            {{ isoData?.iso42001Check ? 'Si' : 'No' }}
          </span>
        </div>
      </div>

      <div
        *ngIf="isoData?.iso42001Check"
        class="flex gap-3 items-start">
        <input
          *ngIf="reviewMode && !readonlyReview"
          type="checkbox"
          class="mt-1"
          [checked]="reviewFields.isFieldMarked('csvISO42001')"
          (change)="reviewFields.toggleField('csvISO42001')" />
        <div class="flex flex-col gap-2">
          <div class="flex items-start gap-2">
            <span class="text-[14px] text-neutral-dark">CSV</span>
            <app-tooltip
              *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('csvISO42001')"
              class="-mt-2"
              [description]="previousReviewText('csvISO42001')"
              tipeIcon="info"></app-tooltip>
          </div>
          <span class="text-[16px] font-regular whitespace-pre-line">
            {{ isoData?.csvISO42001 || '-' }}
          </span>
        </div>
      </div>
    </div>

    <div
      *ngIf="isoData?.iso42001Check"
      class="flex gap-3 items-start">
      <input
        *ngIf="reviewMode && !readonlyReview"
        type="checkbox"
        class="mt-1"
        [checked]="reviewFields.isFieldMarked('iso42001')"
        (change)="reviewFields.toggleField('iso42001')" />
      <div class="flex flex-col gap-2">
        <div class="flex items-start gap-2">
          <span class="text-[14px] text-neutral-dark">Descripcion</span>
          <app-tooltip
            *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('iso42001')"
            class="-mt-2"
            [description]="previousReviewText('iso42001')"
            tipeIcon="info"></app-tooltip>
        </div>
        <span class="text-[16px] font-regular whitespace-pre-line">
          {{ isoData?.iso42001 || '-' }}
        </span>
      </div>
    </div>
  </div>
</div>
